module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"h1":"Welcome to our Help Centre. How can we help you?","h2":"With our Quickstart Guides, you can discover the answers to all your questions, including how to use our comparison and switching services, how the cancellation process works and more. "}}')
  delete Component.options._Ctor
}
